import { render, staticRenderFns } from "./MyAccountSideBar.vue?vue&type=template&id=62d3bea6"
import script from "./MyAccountSideBar.vue?vue&type=script&lang=js"
export * from "./MyAccountSideBar.vue?vue&type=script&lang=js"
import style0 from "./MyAccountSideBar.vue?vue&type=style&index=0&id=62d3bea6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports